import { render, staticRenderFns } from "./StudyProgressDialog.vue?vue&type=template&id=637c3aee"
import script from "./StudyProgressDialog.vue?vue&type=script&lang=js"
export * from "./StudyProgressDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports